"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Colors = void 0;
var Colors;
(function (Colors) {
    Colors["Blue100"] = "#E5F2FF";
    Colors["Blue150"] = "#ADD1FF";
    Colors["Blue200"] = "#7AB4FF";
    Colors["Blue300"] = "#3688FF";
    Colors["Blue400"] = "#146AFF";
    Colors["Blue500"] = "#0653D9";
    Colors["Blue600"] = "#003EB2";
    Colors["Blue650"] = "#002982";
    Colors["Blue700"] = "#00165C";
    Colors["Green100"] = "#E8FCE8";
    Colors["Green150"] = "#B0EFB0";
    Colors["Green200"] = "#7DE37D";
    Colors["Green300"] = "#32C732";
    Colors["Green400"] = "#00B000";
    Colors["Green500"] = "#009C00";
    Colors["Green600"] = "#008500";
    Colors["Green650"] = "#006100";
    Colors["Green700"] = "#003300";
    Colors["Yellow100"] = "#FFFAD6";
    Colors["Yellow150"] = "#FFEF9A";
    Colors["Yellow200"] = "#FFE56F";
    Colors["Yellow300"] = "#FFD02C";
    Colors["Yellow400"] = "#FFBF00";
    Colors["Yellow500"] = "#D39B00";
    Colors["Yellow600"] = "#A77700";
    Colors["Yellow650"] = "#714D00";
    Colors["Yellow700"] = "#382300";
    Colors["Red100"] = "#FFEFEB";
    Colors["Red150"] = "#FFC0B0";
    Colors["Red200"] = "#FF997D";
    Colors["Red300"] = "#FF623D";
    Colors["Red400"] = "#FF401A";
    Colors["Red500"] = "#D92B0B";
    Colors["Red600"] = "#B21A00";
    Colors["Red650"] = "#820E00";
    Colors["Red700"] = "#4D0000";
    Colors["Grey100"] = "#F2F4F8";
    Colors["Grey150"] = "#DDE1E6";
    Colors["Grey200"] = "#C1C7CD";
    Colors["Grey300"] = "#A2A9B0";
    Colors["Grey400"] = "#878D96";
    Colors["Grey500"] = "#697077";
    Colors["Grey600"] = "#4C5258";
    Colors["Grey650"] = "#2F3439";
    Colors["Grey700"] = "#171D21";
    Colors["Black"] = "#000000";
    Colors["White"] = "#FFFFFF";
    Colors["TripadvisorGreen"] = "#00AA6C";
})(Colors || (exports.Colors = Colors = {}));
//# sourceMappingURL=Colors.js.map